/*
Documentation

this page holds all of our layouts and functions
that need to fire before the app runs

*/

import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { setArticles } from 'store/functions/articles';

import Site from 'views/site/layout';

import SystemAlert from './components/markup/system/Alert'
import SystemLoader from './components/markup/system/Loader'

class App extends Component {

    state = {
        loaded: true,
        error: false
    };

    componentDidMount = async () => {

        setArticles()

    }

    render() {

        if(!this.state.loaded) {
            return <div></div>
        }

        if(this.state.error) {
            return <div className="text-center pt-6"><h2>AN ERROR HAS OCCURRED WITH OUR SERVERS.</h2></div>
        }

        return (

            <>

                <SystemAlert />
                <SystemLoader />
                
                <BrowserRouter>
                    <Switch>
                
                        <Route path="/" render={props => <Site {...props} /> } />

                    </Switch>
                </BrowserRouter>

            </>

        )

    }

}

export default App;